import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import React from 'react'

const useStyles = makeStyles(() => ({
    textFieldLabel: {
        fontSize: pxToRem(14),
    },
    label: {
        fontSize: pxToRem(14),
        color: '#04325B',
        '&.MuiInputLabel-shrink': {
            transform: 'translate(0, -1.5px) scale(1)',
            textTransform: 'uppercase',
        },
    },
}))

interface SearchTextFieldProps {
    label: string
    placeholder: string
    name: string
    value: string | undefined
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}
const SearchTextField: React.FC<SearchTextFieldProps> = ({
    label,
    placeholder,
    name,
    value,
    onChange,
}) => {
    const classes = useStyles()
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event)
    }
    return (
        <TextField
            className="searchTextField"
            label={label}
            name={name}
            placeholder={placeholder}
            InputLabelProps={{
                shrink: true,
                className: classes.label,
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton aria-label="search button">
                            <SearchIcon />
                        </IconButton>
                    </InputAdornment>
                ),
                className: classes.textFieldLabel,
            }}
            onChange={handleChange}
            value={value}
            inputProps={{
                'aria-autocomplete': 'none',
                autoComplete: 'chrome-off',
            }}
        />
    )
}

export default SearchTextField
